import apiClient from './client';
import { BaseItineraryItem } from '../types';

export const itineraryService = {
  // Get all itinerary items for a trip
  getTripItinerary: async (tripId: string): Promise<BaseItineraryItem[]> => {
    const response = await apiClient.get<BaseItineraryItem[]>(`/trips/${tripId}/itinerary`);
    console.log('Itinerary API Response:', response.data);
    return response.data;
  },

  // Get itinerary items by date range
  getItineraryByDateRange: async (
    tripId: string,
    startDate: string,
    endDate: string
  ): Promise<BaseItineraryItem[]> => {
    const response = await apiClient.get<BaseItineraryItem[]>(
      `/trips/${tripId}/itinerary/date-range`,
      { params: { startDate, endDate } }
    );
    return response.data;
  },

  // Get itinerary items by type
  getItineraryByType: async (tripId: string, itemType: string): Promise<BaseItineraryItem[]> => {
    const response = await apiClient.get<BaseItineraryItem[]>(
      `/trips/${tripId}/itinerary/type/${itemType}`
    );
    return response.data;
  },

  // Get upcoming itinerary items
  getUpcomingItinerary: async (tripId: string): Promise<BaseItineraryItem[]> => {
    const response = await apiClient.get<BaseItineraryItem[]>(
      `/trips/${tripId}/itinerary/upcoming`
    );
    return response.data;
  },

  // Get itinerary item by ID
  getItineraryItem: async (tripId: string, itemId: number): Promise<BaseItineraryItem> => {
    const response = await apiClient.get<BaseItineraryItem>(
      `/trips/${tripId}/itinerary/${itemId}`
    );
    return response.data;
  },

  // Create itinerary item
  createItineraryItem: async (
    tripId: string,
    item: Partial<BaseItineraryItem>
  ): Promise<BaseItineraryItem> => {
    const response = await apiClient.post<BaseItineraryItem>(
      `/trips/${tripId}/itinerary`,
      item
    );
    return response.data;
  },

  // Update itinerary item
  updateItineraryItem: async (
    tripId: string,
    itemId: number,
    item: Partial<BaseItineraryItem>
  ): Promise<BaseItineraryItem> => {
    const response = await apiClient.put<BaseItineraryItem>(
      `/trips/${tripId}/itinerary/${itemId}`,
      item
    );
    return response.data;
  },

  // Delete itinerary item
  deleteItineraryItem: async (tripId: string, itemId: number): Promise<void> => {
    await apiClient.delete(`/trips/${tripId}/itinerary/${itemId}`);
  },

  // Upload document for parsing
  uploadAndParseDocument: async (tripId: string, file: File): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post(
      `/trips/${tripId}/itinerary/document-parse`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },

  // Parse booking text with AI
  parseBookingText: async (tripId: string, text: string): Promise<any> => {
    const response = await apiClient.post(
      `/trips/${tripId}/itinerary/text-parse`,
      { text }
    );
    return response.data;
  },

  // Upload document to itinerary item
  uploadDocument: async (tripId: string, itemId: number, file: File): Promise<{ url: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await apiClient.post<{ url: string }>(
      `/trips/${tripId}/itinerary/${itemId}/document`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return response.data;
  },

  // Get itinerary item members
  getItineraryMembers: async (tripId: string, itemId: number): Promise<any[]> => {
    const response = await apiClient.get(`/trips/${tripId}/itinerary/${itemId}/members`);
    return response.data;
  },

  // Tag members to itinerary item
  tagMembers: async (tripId: string, itemId: number, memberIds: number[]): Promise<void> => {
    await apiClient.post(`/trips/${tripId}/itinerary/${itemId}/members`, { memberIds });
  },
};
